import AsyncSelect from "react-select/async";
import axiosInstance from "../../axiosInstance";

const toOption = (item) => ({
  value: item.customerCode,
  label: item.name ? `${item.customerCode} - ${item.name}` : item.customerCode,
  customer: item,
});

const loadOptions = async (keyword) => {
  try {
    const res = await axiosInstance.get("/api/warehouse/customers", { params: { keyword } });
    return (res.data?.data || []).map(toOption);
  } catch {
    return [];
  }
};

/** Chọn khách hàng theo Mã KH / Tên khách hàng (BRD §5.1). */
const CustomerAsyncSelect = ({ value, onChange, autoFocus, isDisabled, ...rest }) => (
  <AsyncSelect
    cacheOptions
    defaultOptions
    loadOptions={loadOptions}
    value={value}
    onChange={onChange}
    autoFocus={autoFocus}
    isDisabled={isDisabled}
    placeholder="Tìm theo Mã KH hoặc tên khách hàng..."
    noOptionsMessage={() => "Không tìm thấy khách hàng"}
    loadingMessage={() => "Đang tìm..."}
    classNamePrefix="warehouse-customer"
    {...rest}
  />
);

export default CustomerAsyncSelect;
